import http from '../../Utils/http';
const Comment = {
    name: 'Comments',
    state: {
        id: 0,
        comments: [],
        loading: false,
    },
    reducers: {
        commentRequested(state) {
            return {
                id: 0,
                comments: [],
                loading: true,
            };
        },

        commentReceived(state, payload) {
            if (payload && Array.isArray(payload?.data?.data?.rows)) {
                const comments = payload?.data?.data?.rows?.map((comment) => ({
                    id: comment?.id,
                    user_id: comment?.user_id,
                    camp_id: comment?.camp_id,
                    comment: comment?.commentText,
                    name: comment?.user?.name,
                    created_at: comment?.createdAt,
                    replies: Array.isArray(comment.replies) ? comment.replies.map(reply => ({
                        id: reply.id,
                        user_id: reply.replier_id,
                        comment_id: reply.comment_id,
                        camp_id: comment?.camp_id,
                        name: reply.replier?.name,
                        comment: reply.reply,
                        created_at: reply.createdAt,
                    })) : [],
                }));
                return {
                    ...state,
                    comments: comments,
                    loading: false,
                };
            }
            return {
                ...state,
                comments: [],
                loading: false,
            };
        },

        commentRequestFailed(state, payload) {
            return {
                ...state,
                error: payload,
                loading: false,
            };
        },
    },
    effects: (dispatch) => ({
        async postComment({ user_id, camp_id, commentText, comment_id }) {
            this.commentRequested();
            try {
                const userInfo = JSON.parse(localStorage.getItem('userInfo'));
                const payload = {
                    user_id: user_id,
                    camp_id: camp_id,
                    commentText: commentText,
                    comment_id: comment_id || null,
                };
                await http.post(`savvy/comments`, payload);
                const response = userInfo?.organization?.type === 'DSO' ?
                    await http.get(`savvy/comments/camp/users?user_id=${user_id}&camp_id=${camp_id}`) :
                    (await http.get(`savvy/comments/camp/${camp_id}`));

            
                this.commentReceived(response);
            } catch (err) {
                console.log(err);
                this.commentRequestFailed(err);
            }
        },
        async getAllComments({ camp_id }) {
            try {
                this.commentRequested();
                const response = await http.get(`savvy/comments/camp/${camp_id}`);
                this.commentReceived(response);
            } catch (err) {
                console.log(err);
                this.commentRequestFailed(err);
            }
        },
        async getUserAllComments({ user_id, camp_id }) {
            try {
                this.commentRequested();
                const response = await http.get(`savvy/comments/camp/users?user_id=${user_id}&camp_id=${camp_id}`);
                this.commentReceived(response);
            } catch (err) {
                console.log(err);
                this.commentRequestFailed(err);
            }
        },
        async clearImmediately() {
            this.commentRequested();
        }
    }),
};

export default Comment;
